'use client';

import cx from 'classnames';

import PauseIcon from '~/ui/assets/icons/pause.svg';
import PlayIcon from '~/ui/assets/icons/play.svg';

import { Button, type ButtonProps, ButtonSize, ButtonVariant } from '..';
import styles from './playPause.module.scss';

interface PlayPauseButtonProps {
  onClick?: NonNullable<ButtonProps['onClick']>;
  isPaused: boolean;
  className?: string;
  variant?: ButtonVariant;
  ariaLabels?: {
    paused: string;
    playing: string;
  };
}

export const PlayPauseButton = ({
  onClick,
  isPaused,
  className,
  variant = ButtonVariant.SECONDARY_TRANSPARENT,
  ariaLabels = {
    paused: 'Play background',
    playing: 'Pause background',
  },
}: PlayPauseButtonProps) => {
  return (
    <Button
      size={ButtonSize.ICON}
      className={cx(styles.button, className, {
        [styles.primaryTransparent]: variant === ButtonVariant.PRIMARY_TRANSPARENT,
        [styles.secondaryTransparent]: variant === ButtonVariant.SECONDARY_TRANSPARENT,
      })}
      variant={variant}
      aria-label={isPaused ? ariaLabels.paused : ariaLabels.playing}
      onClick={onClick}
    >
      {isPaused ? (
        <PlayIcon className={styles.iconPlayPause} aria-hidden />
      ) : (
        <PauseIcon className={styles.iconPlayPause} aria-hidden />
      )}
    </Button>
  );
};
